import React, { Component } from "react"
import { subscribe } from "../../services/klaviyo"
import { isBrowser } from "../../services/browser"
import { cvgTrack } from "../../services/converge";

class KlaviyoSubscribe extends Component {
  state = {
    status: null,
    message: null,
    isSubmitted: false
  };

  submit(email, list = null, dob = null, listId = null, kibling = false) {
    const state = this.state;

    if (state.status !== 'success'
      && state.isSubmitted === false
      && email
      && email.indexOf("@") > -1) {
      this.setState({
        isSubmitted: true
      });

      if (isBrowser()) {
        const dobParsed = dob?.split("/");
        cvgTrack({
          event: 'Signed Up For Newsletter',
          properties: {email: email, list, list_id: listId},
          profileProperties: {
            $email: email,
            $date_of_birth: dobParsed ? `${dobParsed[2]}-${dobParsed[0]}-${dobParsed[1]}` : undefined
        },
          aliases: email ? [`urn:email:${email}`] : []
        })
        
        let liQ = window.liQ || [];

        if (typeof liQ !== "undefined") {
          liQ.push({
            event: "conversion",
            name: "email_signup",
            email: email,
          })
        }
      }

      subscribe(email, list, dob, listId, kibling)
        .then(response => {
          this.setState({
            isSubmitted: false,
            status: response.status,
            message: response.message
          });
        });
    }
  }

  render() {
    const {status, message} = this.state;
    const {children} = this.props;

    const childrenComponent = React.cloneElement(children, {
      submit: this.submit.bind(this),
      status: status,
      message: message
    });

    return (
      childrenComponent
    );
  }
}

export default KlaviyoSubscribe;
